import { useQuery } from '@apollo/client';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { GET_ALL_CART_PRODUCTS } from '../../../components/customers/cart/hooks/useCart';
import Icon from '../../Icon';
import { GET_TOTAL_CART_PRODUCTS } from '../../SharedQueries';
// import { TooltipFlag } from '../../components/customers/common/filter/Styles';

const Wrapper = styled.div`
  position: relative;
  padding-right: 16px;
  @media (max-width: 992px) {
    padding-right: 0px;
  }
`;
const CartWrapper = styled.div`
  position: relative;
  display: inline;
  /* svg {
    height: 30px;
    width: 30px;
  } */

  .cart-items-count-badge {
    color: white;
    border: 2px solid white;
    background-color: #a83569;
    position: absolute;
    left: 15px;
    bottom: -2px;
    font-size: 11px;
    font-weight: 100;
    line-height: 20px;
    border-radius: 50%;
    width: 20px !important;
    height: 20px !important;
    text-align: center;
    display: inline-block;
    border-width: 1px;
  }

  /* svg {
    height: 30px;
    width: 30px;
    path {
      fill: white;
    }
  } */

  @media (max-width: 992px) {
    /* svg {
      height: 30px;
      width: 30px;
      path {
        fill: black;
      }
    } */

    .cart-items-count-badge {
      left: 19px;
      bottom: 6px;
    }
  }
`;

function Cart({ className }) {
  const isAuthenticated = useSelector(state => state.Auth.isAuthenticated);
  // const user = useSelector(state => state.Auth.user);
  const total = useSelector(state => state.LocalCart.total);

  useQuery(GET_ALL_CART_PRODUCTS, { skip: !isAuthenticated });
  const { loading, data, error } = useQuery(GET_TOTAL_CART_PRODUCTS, {
    skip: !isAuthenticated,
    fetchPolicy: 'network-only'
  });

  if (loading) return '';
  if (error) {
    console.log('err', error);
    return '';
  }

  const getCartNumber = () => {
    if (isAuthenticated && data.getTotalCartProducts.total) {
      return data.getTotalCartProducts.total;
    }
    if (!isAuthenticated && total) {
      return total;
    } else {
      return '0';
    }
  };

  return (
    <Wrapper className={className}>
      <Link aria-label="cart" to="/cart">
        <CartWrapper className="cart">
          {/* <CartSVG /> */}
          <Icon icon="ti-cart" size={23} color="black" />
          {getCartNumber() > 0 && (
            <span className="cart-items-count-badge">{getCartNumber()}</span>
          )}
        </CartWrapper>
      </Link>
    </Wrapper>
  );
}

export default Cart;
